module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_8019.ca4d87e6.png";